// Reference https://www.myhealthprac.com/

import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import bgImage from "../../image/home-bg2.png";
import { BsBriefcase, BsPersonCheck } from "react-icons/bs";
import { GoLaw } from "react-icons/go";
import ServicesPopup from "./ServicesPopup";

// บริการทั้งหมด (ดึงชื่อจาก services_page.items.* ใน locale)
const SERVICE_IDS = [
  "tax_planning", "tax_litigation", "gov_audit", "corporate", "notarial",
  "fda_registration", "litigation", "debt", "asset_enforcement", "labor",
  "criminal_special", "family", "valuation", "due_diligence",
  "foreign_compliance", "visa_workpermit", "ai_solution",
];

function HomePage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  return (
    <>
      <style>{`
        .hero-overlay {
          position: absolute;
          width: 100vw;
          height: 100vh;
          background: linear-gradient(90deg, rgba(0,0,0,0.55) 0%, rgba(0,0,0,0.15) 60%, rgba(0,0,0,0.05) 100%);
          z-index: 2;
          left: 0;
          top: 0;
        }
        .hero-bg-image {
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          object-fit: cover;
          z-index: 1;
        }
        .hero-content {
          position: relative;
          z-index: 3;
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          align-items: flex-end;
          height: 100vh;
          padding: 60px 60px 104px; /* เว้นล่างให้แถบบริการ */
          box-sizing: border-box;
        }
        .hero-left {
          color: #fff;
          max-width: 600px;
        }
        .hero-left h1 {
          font-size: 4rem;
          font-weight: 600;
          margin-bottom: 40px;
          line-height: 1.1;
          letter-spacing: 0.05rem;
        }
        .hero-features {
          margin-top: 30px;
        }
        .feature {
          display: flex;
          align-items: flex-start;
          margin-bottom: 22px;
        }
        .feature-icon {
          font-size: 2rem;
          margin-right: 18px;
          margin-top: 2px;
        }
        .feature-desc {
          font-size: 1.05rem;
          opacity: 0.85;
          margin-top: 2px;
        }
        .hero-right {
          color: #fff;
          text-align: left;
          max-width: 600px;
          margin-bottom: 40px;
        }
        .hero-main-text {
          font-size: 2.5rem;
          font-weight: 500;
          margin-bottom: 32px;
          line-height: 1.2;
        }
        .hero-btn {
          background: #fff;
          color: #222;
          border: none;
          border-radius: 30px;
          padding: 6px 32px;
          font-size: 1.15rem;
          font-weight: 500;
          cursor: pointer;
          display: inline-flex;
          align-items: center;
          transition: background 0.2s;
          box-shadow: 0 2px 16px rgba(0,0,0,0.08);
        }
        .hero-btn:hover {
          background: #f5f5f5;
        }
        .arrow {
          font-size: 1.2em;
          margin-left: 8px;
        }

        /* From Uiverse.io by ryota1231 */
        .animated-button {
          position: relative;
          display: flex;
          align-items: center;
          gap: 4px;
          padding: 16px 36px;
          border: 4px solid;
          border-color: transparent;
          font-size: 16px;
          background-color: ;
          border-radius: 100px;
          font-weight: 600;
          color: #000;
          box-shadow: 0 0 0 2px #ffffff;
          cursor: pointer;
          overflow: hidden;
          transition: all 0.6s cubic-bezier(0.23, 1, 0.32, 1);
        }

        .animated-button svg {
          position: absolute;
          width: 24px;
          fill: #000;
          z-index: 9;
          transition: all 0.8s cubic-bezier(0.23, 1, 0.32, 1);
        }

        .animated-button .arr-1 {
          right: 16px;
        }

        .animated-button .arr-2 {
          left: -25%;
        }

        .animated-button .circle {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          width: 20px;
          height: 20px;
          background-color: #e5e7eb;
          border-radius: 50%;
          opacity: 0;
          transition: all 0.8s cubic-bezier(0.23, 1, 0.32, 1);
        }

        .animated-button .text {
          position: relative;
          z-index: 1;
          transform: translateX(-12px);
          transition: all 0.8s cubic-bezier(0.23, 1, 0.32, 1);
        }

        .animated-button:hover {
          box-shadow: 0 0 0 12px transparent;
          color: #212121;
          border-radius: 12px;
        }

        .animated-button:hover .arr-1 {
          right: -25%;
        }

        .animated-button:hover .arr-2 {
          left: 16px;
        }

        .animated-button:hover .text {
          transform: translateX(12px);
        }

        .animated-button:hover svg {
          fill: #000;
        }

        .animated-button:active {
          scale: 0.95;
          box-shadow: 0 0 0 4px greenyellow;
        }

        .animated-button:hover .circle {
          width: 220px;
          height: 220px;
          opacity: 1;
        }

        /* === แถบบริการจางๆ ใน Hero === */
        .hero-services {
          position: absolute;
          left: 0;
          bottom: 0;
          width: 100%;
          z-index: 4;
          display: flex;
          align-items: center;
          padding: 16px 0;
          box-sizing: border-box;
          background: linear-gradient(to top, rgba(0,0,0,0.55), rgba(0,0,0,0));
        }
        .hero-services-marquee {
          position: relative;
          flex: 1;
          overflow: hidden;
          -webkit-mask-image: linear-gradient(to right, transparent, #000 6%, #000 94%, transparent);
          mask-image: linear-gradient(to right, transparent, #000 6%, #000 94%, transparent);
        }
        .hero-services-track {
          display: inline-flex;
          align-items: center;
          white-space: nowrap;
          animation: hero-marquee 70s linear infinite;
          will-change: transform;
        }
        .hero-services-marquee:hover .hero-services-track { animation-play-state: paused; }
        .hero-service-item {
          background: none;
          border: none;
          cursor: pointer;
          font-family: inherit;
          color: rgba(255,255,255,0.5);
          font-size: 0.92rem;
          font-weight: 500;
          padding: 0 4px;
          transition: color 0.25s ease;
          white-space: nowrap;
        }
        .hero-service-item:hover { color: #D4AF37; }
        .hero-service-sep { color: rgba(212,175,55,0.55); padding: 0 10px; font-size: 0.65rem; }
        @keyframes hero-marquee {
          from { transform: translateX(0); }
          to { transform: translateX(-50%); }
        }
        @media (prefers-reduced-motion: reduce) {
          .hero-services-track { animation: none; }
        }

        /* Mobile adjustments */
        @media (max-width: 900px) {
          .hero-content {
            flex-direction: column;
            align-items: flex-start;
            padding: 96px 16px 32px; /* add top space under fixed navbar */
            height: auto;
          }
          .hero-left, .hero-right {
            max-width: 100%;
            margin-bottom: 32px;
          }
          .hero-main-text {
            font-size: 2rem;
          }
          .hero-left h1 {
            font-size: 2rem;
            margin-bottom: 16px; /* reduce spacing on mobile */
          }
          .hero-services {
            position: static;
            padding: 14px 0;
            background: rgba(0,0,0,0.3);
          }
        }
      `}
      </style>

      <div
        className="hero-section"
        style={{
          fontFamily: "Prompt, sans-serif",
          position: "relative",
          width: "100vw",
          height: "auto",
          minHeight: "100vh",
          overflow: "hidden",
        }}
      >
        {/* Background Image (Previously Video) */}
        <img className="hero-bg-image" src={bgImage} alt="Legal background" />

        <div className="hero-overlay" />
        <div className="hero-content">
          <div className="hero-left">
            <h1 dangerouslySetInnerHTML={{ __html: t("home.hero_title") }} />
            <div className="hero-features">
              <div className="feature">
                <span className="feature-icon"><BsBriefcase /></span>
                <div>
                  <strong>CPA</strong>
                  <div className="feature-desc">
                    {t("home.feature_cpa_desc")}
                  </div>
                </div>
              </div>
              <div className="feature">
                <span className="feature-icon"><GoLaw /></span>
                <div>
                  <strong>{t("home.feature_lawyer_title")}</strong>
                  <div className="feature-desc">
                    {t("home.feature_lawyer_desc")}
                  </div>
                </div>
              </div>
              <div className="feature">
                <span className="feature-icon"><BsPersonCheck /></span>
                <div>
                  <strong>{t("home.feature_expert_title")}</strong>
                  <div className="feature-desc">
                    {t("home.feature_expert_desc")}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="hero-right">
            <div className="hero-main-text">
              {t("home.hero_desc").split("—").map((part, i) => i === 1 ? <><br />— {part}</> : part)}
            </div>
            <button class="animated-button" onClick={() => navigate("/service")}>
              <svg xmlns="http://www.w3.org/2000/svg" class="arr-2" viewBox="0 0 24 24">
                <path d="M16.1716 10.9999L10.8076 5.63589L12.2218 4.22168L20 11.9999L12.2218 19.778L10.8076 18.3638L16.1716 12.9999H4V10.9999H16.1716Z"></path>
              </svg>
              <span class="text">{t("home.btn_services")}</span>
              <span class="circle"></span>
              <svg xmlns="http://www.w3.org/2000/svg" class="arr-1" viewBox="0 0 24 24">
                <path d="M16.1716 10.9999L10.8076 5.63589L12.2218 4.22168L20 11.9999L12.2218 19.778L10.8076 18.3638L16.1716 12.9999H4V10.9999H16.1716Z"></path>
              </svg>
            </button>
          </div>
        </div>

        {/* แถบรายชื่อบริการจางๆ เลื่อนช้าๆ (hover เพื่อหยุด/คลิก) */}
        <div className="hero-services">
          <div className="hero-services-marquee">
            <div className="hero-services-track">
              {[...SERVICE_IDS, ...SERVICE_IDS].map((id, i) => (
                <React.Fragment key={i}>
                  <button
                    type="button"
                    className="hero-service-item"
                    onClick={() => navigate(`/service#${id}`)}
                  >
                    {t(`services_page.items.${id}.title`)}
                  </button>
                  <span className="hero-service-sep">•</span>
                </React.Fragment>
              ))}
            </div>
          </div>
        </div>
      </div>

      <ServicesPopup />
    </>
  );
}

export default HomePage;

